import React, { useState, useRef, useMemo, Suspense, useEffect } from 'react';
// import * as THREE from 'three';
import { ExtrudeGeometry, Vector3, MathUtils, BackSide, FrontSide, Shape, VideoTexture, RGBAFormat, AnimationMixer, TextureLoader } from 'three'; // RepeatWrapping, TextureLoader, PlaneGeometry,  SubtractiveBlending, MultiplyBlending, AdditiveBlending
import { Canvas, useThree, useFrame, useLoader, useGraph  } from '@react-three/fiber'; // extend, 
import { Reflector, CameraShake, OrbitControls, useTexture, useAspect, Text, useAnimations, Html, Sky } from '@react-three/drei'; 
import { Cloud } from './Cloud';
import Loader from '../Loader/Loader';

// import { KernelSize } from 'postprocessing';
// import { EffectComposer, Bloom } from '@react-three/postprocessing';
import { SVGLoader } from 'three/examples/jsm/loaders/SVGLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
// import { Water } from 'three-stdlib';

import useIsBreakpoint from '../../hooks/useIsBreakpoint'; 

import { clone } from "three/examples/jsm/utils/SkeletonUtils";

// import parrotGlb from '../../glb/Parrot.glb';
// import storkGlb from '../../glb/Stork.glb';
// import flamingoGlb from '../../glb/Flamingo.glb';
import seagullGlb from '../../glb/seagull.glb';
import birdGlb from '../../glb/simple_bird.glb';
import bird2Glb from '../../glb/birdflap.glb';
//import bird2Glb from '../../glb/flying_bird.glb';

// import libertyPlaceGlb from '../../glb/liberty_place_in_philadelphia.glb';
// import philadelphiaSkylineImg from '../../images/philadelphia/skyline-9.png';

// skyline-4.png'
// philadelphia-skyline.png
// stabilityai-philly-9.jpg
// philadelphia-skyline-silhouette-13.png
// stabilityai-philly-14.jpg
// 1000_F_159093735_n6YEGlg3MGNEiKhmJIoApbsPaVKdcRyF.jpg
// 1000_F_32600284_3eddLe7cw5D3JxSWGPhOIOCVvPIWtaXn.jpg
// stock-vector-philadelphia-pa-usa-low-poly-skyline-clip-art-city-design-geometric-polygon-graphic-horizon-icon-2006561615.jpg
// istockphoto-694898224-612x612.jpg
// philadelphia-city-skyline-negative-space-silhouette-vector-illustration-150477029.jpg
// philadelphia-skyline-silhouette-1.png
// xcgaEB9Ai.jpg


// depositphotos_5709285-stock-illustration-skyline-philadelphia.jpg
// import SkyDomeImage from '../../images/sky-dome/shutterstock_1048620689-quality-30.jpg';
//++ import SkyDomeImage from '../../images/sky-dome.jpg'; // file named dynamically below
import SkyDomeImage from '../../images/philadelphia/skyline-8e.png';
// import SkyDome2Image from '../../images/pink-sky-background-with-white-clouds-fantasy-cloudy-sky-abstract-image-use-background_156745-959.webp';

import SkyDome2Image from '../../images/sky/j-lee-H4ui9lt7GRE-unsplash-v2-q50.jpg';
// import SkyDome2Image from '../../images/pexels-dimitri-baret-10372463-v2.jpg';
// import SkyDome2Image from '../../images/pexels-anete-lusina-6331085-v2.jpg';

// import SkyDome2Image from '../../images/sky/15_mei_2.jpg';
// import SkyDome2Image from '../../images/sky/x-wen-qjCHPZbeXCQ-unsplash.jpg';

// import SkyDome2Image from '../../images/pexels-ithalu-dominguez-907485-v2.jpg';
//* import SkyDome2Image from '../../images/sky/avinash-kumar-WsG7CLEJCGw-unsplash.jpg';
// import SkyDome2Image from '../../images/sky/dollar-gill-2sf6UjjrREw-unsplash.jpg'; // violet
//* import SkyDome2Image from '../../images/sky/j-lee--IiET8hGAec-unsplash.jpg';

// import SkyDome2Image from '../../images/sky/joshua-fuller-t_VAvlLfTJk-unsplash-v2.jpg';
// import SkyDome2Image from '../../images/sky/linus-nylund-JP23z_-dA74-unsplash-v2.jpg';
// import SkyDome2Image from '../../images/pink-sky-dpyuqw-93dc38d5-655c-4b59-8818-2405a1827805.jpg';
// skyline-8.png

// const CloudsVideo = 'clouds_2.mp4';



const imagesToPreload = [];
const svgsToPreload = [];


// extend({ Water })

const Icon = ({ url, colors, depth, bevelSegments, ...props }) => {
  const ref = useRef()
  const [r] = useState(() => Math.random() * 10000);
  useFrame((_) => (ref.current.position.y = -1.75 + Math.sin(_.clock.elapsedTime + r) / 10));
  //const { paths: [path] } = useLoader(SVGLoader, TriangleSvg) // prettier-ignore
  // const geom = useMemo(() => SVGLoader.pointsToStroke(path.subPaths[0].getPoints(), path.userData.style), [])
 
  const svgData = useLoader(SVGLoader, url);

  const geometries = useMemo(() => { // Without useMemo, runs too slowly for onscroll updates
    
    let geoms = [];

    // Loop through all of the parsed paths
    svgData.paths.forEach((path, i) => {
      const shapes = path.toShapes(true);

      // Each path has array of shapes
      shapes.forEach((shape, j) => {
        // Finally we can take each shape and extrude it
        geoms.push(new ExtrudeGeometry(shape, {
          depth: depth,
          // bevelEnabled: false,
          bevelEnabled: true,
          bevelThickness: 1,
          bevelSize: 1,
          bevelOffset: 0,
          bevelSegments: bevelSegments,
          material: 0, // position in material array
          extrudeMaterial: 1  // position in material array
        }));
      });
    });
    return geoms;
  }, [svgData, bevelSegments, depth]);


  return (
    <group ref={ref}>
      {geometries.map((geom, index) => (
        <mesh key={geom.uuid} geometry={geom} {...props} > 
          {colors[index] && colors[index].material==='basic' 
           ? <meshBasicMaterial color={colors[index].color} toneMapped={false} />
           : <>
              <meshLambertMaterial attachArray="material" color={colors[index].color} />
              <meshBasicMaterial attachArray="material" color={colors[index].color2} />
            </>
          }
        </mesh>          
       ))}
    </group>
  )
}



const Rig = ({ startCameraPosition, endCameraPosition, children }) => {
  const rigRef = useRef();
  const vec = new Vector3();
  const { camera, mouse } = useThree();

  const isMobile = useIsBreakpoint(600);
/*
  const beginRigRotationY = -Math.PI;
  const   = 0;
*/
  useFrame(({ clock }) => {
    // camera.position.x = MathUtils.lerp(camera.position.x, endCameraPosition.x, .01);
    // camera.position.y = MathUtils.lerp(camera.position.y, endCameraPosition.y, .01);
    // camera.position.z = MathUtils.lerp(camera.position.z, endCameraPosition.z, .01);
    // camera.rotation.y = MathUtils.lerp(camera.rotation.y, 0, .01);
    
    // camera.position.lerp(vec.set(mouse.x * 2, 0, 3.5), 0.05); // move 5% of distance to provided vector
    // camera.position.lerp(vec.set(0, 0, 3.5), 0.05);

      // Don't set... CameraShake takes over
      /*
      camera.rotation.x = 0;
      camera.rotation.y = 0;
      camera.rotation.z = 0; 
      */

  });

  return <group ref={rigRef} rotation={[0, 0, 0]}>
      {children}
    </group>
}

const SkyDome = ({ isMobile, isLargeScreen, imagePrefix, endCameraPosition, children, ...props }) => {

  // const skyDomeRef = useRef();
  // const { camera } = useThree();

  const skyTexture = useTexture(SkyDomeImage);
  const sky2Texture = useTexture(SkyDome2Image);

  /*
  useFrame(()=> {
  });
  */
// linear-gradient(0deg, rgba(255, 215, 185, 0.91) 23%, rgba(223, 198, 234, 0.8) 93%)
// linear-gradient(0deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)
  return (
    skyTexture && sky2Texture 
    ? <>

        <mesh 
          rotation={[0, 0, 0]} 
          position={[0, -250, -50]}
          castShadow={true}
          receiveShadow={true}
        >
          <sphereBufferGeometry attach="geometry" args={[760, 25, 25]} />
          <meshPhongMaterial 
            attach="material" 
            map={sky2Texture} 
            side={BackSide}
            transparent={true}
          />
        </mesh>

        <mesh 
          // ref={skyDomeRef} 
          rotation={[0, isMobile ? -Math.PI/6 : Math.PI/22, 0]} 
          position={[0, isMobile ? -250 : -150, -50]}
          castShadow={true}
          receiveShadow={true}
        >
          <sphereBufferGeometry attach="geometry" args={[400, 25, 25]} />
          <meshPhongMaterial 
            attach="material" 
            map={skyTexture} 
            side={BackSide}
            transparent={true}
          />
        </mesh>

        <Html 
          center={true} 
          transform={false} 
          rotation={[0, -Math.PI / 4, 0]} 
          position={[0, 7, 0]} 
          scale={isLargeScreen ? 4 : isMobile ? 3.5 : 3}
          occlude={true}
        >
          <div className="services-foreground-container">
            {children}
          </div>
        </Html>
      </>
    : <></>
  )
};
/*
// skyline-8.png
    <mesh ref={skyDomeRef} rotation={[0, Math.PI/4, 0]} position={[0, 20, -50]}>
      <sphereBufferGeometry attach="geometry" args={[700, 25, 25]} />
      <meshPhongMaterial 
        attach="material" 
        map={skyTexture} 
        side={BackSide}
        transparent={true}
      />
    </mesh>
*/
const CameraShaker = ({sectionEndReachedRef}) => {
    
    // const intensity = useRef(1);
    const cameraShakeRef = useRef();

    /*
    // To stop shaking at end of sequence...
    useFrame(()=> {
      if (sectionEndReachedRef.current===true && intensity.current>0) {
        cameraShakeRef.current.setIntensity(intensity.current-.02);
        intensity.current -= .02;
      } else if (sectionEndReachedRef.current===false && intensity.current<1) {
        cameraShakeRef.current.setIntensity(intensity.current+.02);
        intensity.current += .02;
      }
    });
    */

    return (
      <CameraShake 
        ref={cameraShakeRef}
        // decay={false}
        // decayRate={.65}
        yawFrequency={.3} 
        pitchFrequency={.3} 
        rollFrequency={.3} 
      />
    )
};



// This component was auto-generated from GLTF by: https://github.com/react-spring/gltfjsx
const Bird = ({ model, birdName, birdNumber, speed, factor, url, ...props }) => {
 
  const { scene, materials, animations } = model;
  // const { RootNode, root } = nodes;

 
    // const { scene, materials, animations } = useGLTF('/simple_door.gltf');

  // Must clone scene in order for primitive to work and display multiple copies ... 
  // Multiple primitives of the same object results in only one being displayed
  const sceneClone = useMemo(() => clone(scene), [scene]); // scene.clone() will not work with animations
  const { nodes } = useGraph(sceneClone);


/*
  const sceneClone = useMemo(() => {
    return scene.clone();
  }, [scene])

  const nodesClone = useMemo(() => {
    return {...nodes};
  }, [nodes])
*/
  //const { ref, mixer, names, actions, clips } = useAnimations(animations)
  
  const sceneGroup = useRef();
  const birdRef = useRef();

  const { actions } = useAnimations(animations, birdRef);

  useEffect(() => {
    const key = Object.keys(actions)[0]; 
    actions[key].play();
    /*
    if (birdName==='Bird') {
      actions.Flying?.play();  // works with primitive // .reset().
    } else {
      actions.KeyAction?.play();
      // console.log('actions', actions);
    }
    */
  }, [actions, birdName]);

  // const actions = useRef();
  const [start] = useState(() => Math.random() * 5000);
  const [mixer] = useState(() => new AnimationMixer());

  /*
  useEffect(() => {
    console.log('actions', actions);
    //actions.Flying.play();  // works with primitive

    const group = meshesGroup.current;
    if (birdName==='Bird') {
      /*
      actions.current = { idle: mixer.clipAction(animations[0], groupCurrent) }
      actions.current.idle.play()
      return () => animations.forEach((clip) => mixer.uncacheClip(clip))
      *//*
     console.log('play', animations);
      actions.current = {
        animation_0: mixer.clipAction(animations[0], group).play() // works with primitive
      }
      return () => animations.forEach(clip => mixer.uncacheClip(clip))

    } else {
      return () => void mixer.clipAction(animations[0], group).play();
    };

  }, [animations, mixer, birdName, actions])
*/

  useFrame((state, delta) => {
   // if (birdName!=='Seagull') {
   /* if (birdName!=='Seagull') {
      console.log('Seagull position', mesh.current.position);
    }
    */

      if (birdRef.current) {
        birdRef.current.position.y = Math.sin(start + state.clock.elapsedTime) * 5;
      
        if (birdName!=='Bird' && birdName!=='Bird2' && birdName!=='Seagull') {
          birdRef.current.rotation.x = Math.PI / 2 + (Math.sin(start + state.clock.elapsedTime) * Math.PI) / 10
          birdRef.current.rotation.y = (Math.sin(start + state.clock.elapsedTime) * Math.PI) / 2;
        }
      
        sceneGroup.current.rotation.y += Math.sin((delta * factor) / 2) * Math.cos((delta * factor) / 2) * 1.5;
        mixer.update(delta * speed);
      }
    
   // }
  })

  return (
    <group ref={sceneGroup} dispose={null}>
      <scene name="Scene" {...props}>

        <group >
          {birdName==='Bird' || birdName==='Bird2' ||birdName==='Seagull'
            ? <primitive
                ref={birdRef}
                scale={birdName==='Bird2' ? 1 : birdName==='Seagull' ? 3 : 1.5}
                rotation={[0, birdName==='Bird2' ? Math.PI : birdName==='Seagull' ? Math.PI / 2 : 0, 0]}
                // object={nodes["RootNode"] || nodes["root"] || nodes["Sketchfab_model"]}
                // object={scene || RootNode || root} 
                // Sketchfab_model
                object={sceneClone}
              />
            : <mesh
                //ref={mesh}
                ref={birdRef}
                scale={1.5}
                name="Object_0"
                morphTargetDictionary={nodes.Object_0.morphTargetDictionary}
                morphTargetInfluences={nodes.Object_0.morphTargetInfluences}
                rotation={[Math.PI / 2, 0, 0]}
                geometry={nodes.Object_0.geometry}
                material={materials.Material_0_COLOR_0}
              />
          }
          {/*Object.keys(nodes).length>0 && Object.keys(nodes).map((key, i) => {
            const node = nodes[key];
            console.log('key', key,  node.geometry ? 'true' : 'false');
            console.log('nodes', nodes);
            console.log('node.geometry', node.geometry);
            return node.geometry
              ? <mesh
                  key={'node-'+i}
                  scale={10.5}
                  name={key}
                  morphTargetDictionary={node?.morphTargetDictionary}
                  morphTargetInfluences={node?.morphTargetInfluences}
                  rotation={[Math.PI / 2, 0, 0]}
                  geometry={node?.geometry}
                  material={node?.material}
                  skeleton={node?.skeleton}
                />
              : <React.Fragment key={'node-'+i} />
          })*/}
          
        </group>
      </scene>
    </group>
  )
}

/*
   <primitive
      scale={1.5}
      name={'Object_0'}
      rotation={[0, Math.PI / 4, 0]}
      // object={nodes["RootNode"] || nodes["root"] || nodes["Sketchfab_model"]}
      // object={scene || RootNode || root} 
      // Sketchfab_model
      object={nodes["Sketchfab_Scene"]}
    />
*/
const Birds = () => {
  const birdModel= useLoader(GLTFLoader, birdGlb);
  const bird2Model= useLoader(GLTFLoader, bird2Glb);
  // const parrotModel = useLoader(GLTFLoader, parrotGlb);
  // const storkModel = useLoader(GLTFLoader, storkGlb);
  // const flamingoModel = useLoader(GLTFLoader, flamingoGlb);
  const seagullModel = useLoader(GLTFLoader, seagullGlb);
  
 
  return new Array(20).fill().map((_, i) => {
    const x = (20 + Math.random() * 80) * (Math.round(Math.random()) ? -1 : 1);
    const y = -10 + Math.random() * 20;
    const z = -5 + Math.random() * 10;
    const bird = ['Bird', 'Bird2', 'Seagull'][Math.round(Math.random() * 2)]; // 'Parrot'
    let speed = bird === 'Stork' ? 0.25 : bird === 'Flamingo' ? 0.5 : bird === 'Parrot' ? 5 : .25;
    let factor = bird === 'Stork' ? 0.5 + Math.random() : bird === 'Flamingo' ? 0.25 + Math.random() : 1 + Math.random() - 0.5
    const model = 
      // bird === 'Stork' 
      //  ? storkModel 
       // : bird === 'Parrot' 
       //   ? parrotModel 
       //   : bird === 'Flamingo' 
       //     ? flamingoModel 
        //    : 
            bird === 'Seagull' 
              ? seagullModel 
              : bird === 'Bird2' 
                ? bird2Model 
                : birdModel;
    return ( 
      <Bird 
        birdName={bird}
        key={i} 
        birdNumber={i}
        position={[x, y, z]} 
        rotation={[0, x > 0 ? Math.PI : 0, 0]} 
        speed={speed} 
        factor={factor} 
        model={model}
        // url={bird === 'Stork' ? storkGlb : bird === 'Parrot' ? parrotGlb : birdGlb} 
      />
    )
  })
}

/*
const LibertyPlace = () => {
  const model = useLoader(GLTFLoader, libertyPlaceGlb);

  const { scene, materials, animations } = model;

  return (
    <primitive
      scale={.055}
      rotation={[0, 0, 0]}
      position={[230, -420, -400]}
      // object={nodes["RootNode"] || nodes["root"] || nodes["Sketchfab_model"]}
      // object={scene || RootNode || root} 
      // Sketchfab_model
      object={scene}
    />
  )
}
*/

/*
const PhiladelphiaSkyline = () => {
  const texture = useLoader(TextureLoader, philadelphiaSkylineImg)

  return (
    <mesh 
      position={[500, -300, -550]} 
      rotation={[0, -Math.PI/3.4, 0]}
      scale={[600, 500, 500]}
    >
      <planeBufferGeometry attach="geometry" args={[3, 3]} />
      <meshBasicMaterial attach="material" map={texture} toneMapped={false} transparent={true} />
    </mesh>
  )
};
*/

/*
// skyline-2.png
  <mesh 
      position={[300, -300, -250]} 
      rotation={[0, -Math.PI/3.4, 0]}
      scale={[700, 500, 500]}
    >
    */

const ServicesBackground = ({ children }) => {

  const svgPrefix = process.env.PUBLIC_URL + '/svgs/';
     
  const imagePrefix = process.env.PUBLIC_URL + '/images/';

  const videoPrefix = process.env.PUBLIC_URL + '/videos/';

  const iconGroupRef = useRef();
  
  const isLargeScreen = !useIsBreakpoint(1024);
  const isMobile = useIsBreakpoint(600);

  const startCameraPosition = {
    x: -75,
    y: 30,
    z: 50
  }

  const endCameraPosition = {
    x: -75,
    y: 30,
    z: 50
  }

/*
  useEffect(()=>{
    const newIconRadiusIncrement = isMobile ? .75 : 0;
    setIconRadiusIncrement(newIconRadiusIncrement);
  }, [isMobile]);
*/
/*
  const startCameraRotation = {
    x: 0,
    y: Math.PI/3,
    z: 0
  }

  const endCameraRotation = {
    x: 0,
    y: 0,
    z: 0
  }
*/

  useEffect(()=> {
    svgsToPreload.forEach((svg) => {
      const img = new Image();
      img.src = svgPrefix+svg;
    });

    imagesToPreload.forEach((image) => {
      const img = new Image();
      img.src = imagePrefix+image;
    });
  }, [svgPrefix, imagePrefix]);

  return (
    <>
      <Suspense 
        fallback={
          <div className="fallback-container">
            <Loader />
          </div>
        }
      >
        <Canvas 
          className="services-canvas-container"
          dpr={[1, 1.5]} 
          camera={{ 
            position: [startCameraPosition.x, startCameraPosition.y, startCameraPosition.z], 
            rotation: [0, 0, 0],
            zoom: 1.35
          }}
          alpha={true} /* Makes background transparent */
        >
          {/* <color attach="background" args={['black']} /> */}
      
          <spotLight 
            position={[-50, 0, 30]} 
            intensity={1} // originally .8
          />
          <OrbitControls enableZoom={false} enablePan={false} enableRotate={false} />
          <Suspense 
            fallback={
              <Html
                center={true} 
                transform={false} 
              >
                <div className="fallback-container">
                  <Loader />
                </div>
              </Html>
            }
          >
            
        
            <SkyDome isMobile={isMobile} isLargeScreen={isLargeScreen} imagePrefix={imagePrefix}>
              {children}
            </SkyDome>
          
            
            <Rig 
              iconGroupRef={iconGroupRef} 
              startCameraPosition={startCameraPosition}
              endCameraPosition={endCameraPosition}
              position={[0, 0, 200]}
            >
              <Birds />
              
              <Cloud
                opacity={1} // .6 if pink background and no <Sky />
                speed={0.4} // Rotation speed
                width={10} // Width of the full cloud
                depth={1.5} // Z-dir depth
                segments={20} // Number of particles
                scale={4}
                position={[50, 0, 0]}
              />

      
  {/*

          

              <LibertyPlace />
              <PhiladelphiaSkyline />

                <mesh position={[150, 80, -400]} scale={12}>
                      <sphereGeometry args={[4, 32, 32]} />
                      <meshLambertMaterial />
                    </mesh>

                        <Sky 
                // sunPosition={[60, 10, 0]} 
                azimuth={0.1} 
                turbidity={10} 
                rayleigh={0.5} 
                inclination={0.6} 
                distance={1000}
              />
  */}
                  
          

            </Rig>


  {/* 
            <EffectComposer multisampling={8}>
              <Bloom kernelSize={3} luminanceThreshold={0} luminanceSmoothing={0.4} intensity={0.6} />
              <Bloom kernelSize={KernelSize.HUGE} luminanceThreshold={0} luminanceSmoothing={0} intensity={0.5} />
            </EffectComposer>
  */}
          </Suspense>
  {/* 
          <CameraShaker sectionEndReachedRef={sectionEndReachedRef} /> 
  */}
      

    
        </Canvas>
      </Suspense>
    </>
  )
}

export default ServicesBackground;
